import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISingleIdParams } from '../../../../spacesPlatform/utils/actionParams';

// NOTE: This request violates the standard contract;
// rather than returning an IResult, it returns a boolean.
// The existing uses check the "truthiness" of the result.
// The API should be changed to adhere to the standard contract.
//
// NOTE: The TestAuthCredentialRequest can test both keypair auth credential and oauth credential.
export class TestAuthCredentialRequest extends Request<ISingleIdParams, IResult> {
  constructor(id: string) {
    super('testAuthCredential', { id: id });
  }
}
